"use client";

import { createContext, type ReactNode, useContext } from "react";

/**
 * Bridges the server-prefetched job count to the (client) CountUp in the
 * filterbar without prop-drilling through the registry-resolved Filterbar.
 * Set on the home page from the prefetched data; read in filterbar-eon so the
 * <h1> count has its correct width on the first paint (no load-time reflow).
 */
const InitialCountContext = createContext<number | undefined>(undefined);

export function InitialCountProvider({
  value,
  children,
}: {
  value: number | undefined;
  children: ReactNode;
}) {
  return (
    <InitialCountContext.Provider value={value}>
      {children}
    </InitialCountContext.Provider>
  );
}

export function useInitialCount() {
  return useContext(InitialCountContext);
}
